import 'formdata-polyfill';

const getFormDataJson = (form: HTMLFormElement): { [k: string]: string } => {
  const elementFormData = new FormData(form).entries();
  const formData: { [k: string]: string } = Array.from(elementFormData).reduce(
    (acc, [key, value]) => ({ ...acc, [key]: value }),
    {}
  );

  return formData;
};

export default getFormDataJson;
